import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import ProteinResultsContainer from "./ProteinResultsContainer";
import isPortal from "../../common/helpers/isPortal";
import ComponentPanel from "../atoms/ComponentPanel/ComponentPanel";

const ProteinViewerContainer = ({ varsomeHost }) => {
  const get3dProteinDocumentationLink = (
    <span className="tw-float-right">
      <span className="tw-mr-5">
        <a
          href={`${varsomeHost}/about/resources/sv-implementation/`}
          target="_blank"
        >
          Documentation
        </a>
      </span>
    </span>
  );
  if (!isPortal()) return null;
  return (
    <div className="varsome-result">
      <div className="varsome-container varsome-container__basic">
        <ComponentPanel
          title={<span>Protein Viewer</span>}
          titleDetailsRight={get3dProteinDocumentationLink}
          content={
            <div className="varsome-inner-container">
              <div className="varsome-horiz-flex">
                <div className="varsome-horiz-list-item">
                  <ProteinResultsContainer />
                </div>
              </div>
            </div>
          }
        />
      </div>
    </div>
  );
};
ProteinViewerContainer.propTypes = {
  varsomeHost: PropTypes.string.isRequired,
};

const mapStateToProps = (state) => ({
  varsomeHost: state.varsomeHost,
});

export default connect(mapStateToProps)(ProteinViewerContainer);
